import { useFlags } from 'launchdarkly-react-client-sdk'
import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { PATHS } from '@/config/router/routes'
import { useAccessControl } from '@/ducks/auth/auth.permissions'
import { selectStoreType } from '@/ducks/store/selectors/store.selectors'

import MarketingToolsPage from './MarketingToolsPage'

const MarketingToolsRoutePage = () => {
  const { lmd_store_webapp_offers_page } = useFlags()
  const storeType = useSelector(selectStoreType)
  const { isRbacEnabled, canManageOffers } = useAccessControl()
  const history = useHistory()

  if (
    (isRbacEnabled && !canManageOffers) ||
    (!isRbacEnabled && (!lmd_store_webapp_offers_page || storeType === 'dark_store'))
  ) {
    return null
  }

  const handleCreateOffer = (
    offerType: 'item_discount' | 'cart_discount' | 'buyX_getY'
  ) => {
    if (offerType === 'item_discount') {
      history.push(PATHS.OFFERS_CREATE)
    } else if (offerType === 'cart_discount') {
      history.push(PATHS.OFFERS_CART_DISCOUNT_CREATE)
    } else {
      history.push(PATHS.OFFERS_BUYX_GETY_CREATE)
    }
  }

  return <MarketingToolsPage onCreateOffer={handleCreateOffer} />
}

export default MarketingToolsRoutePage
